import React, {useEffect, useState} from 'react';
import * as AXIOS from '../../../services/departmentService';
import Swal from 'sweetalert2';
import {getLanguage, t} from 'react-switch-lang';
import {Edit} from '../../../components/modals/ModalEdit';
import {searchDepartments} from './SearchDepartments';
import {Show} from '../../../components/modals/ModalShow';
import {Add} from '../../../components/modals/ModalAdd';
import Loader from '../../../components/loader/Loader';
import TableAdministration from '../../../components/tablesAdministration/Table-administration';
import {Delete} from '../../../components/modals/ModalDelete';
import SearchHeader from './pageHeader/PageHeader';
import {appModuleIdsOptions} from './components/departmentFormOptions';
import Select from 'react-select';
import {Deactivate} from '../../../components/modals/ModalDepartmentDeactivate';

const PAGE_SIZE = 20;

const Departments = () => {
  const [items, setItems] = useState([]);
  const [filterItems, setFilterItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingPage, setIsLoadingPage] = useState(true);
  const [modal, setModal] = useState(false);
  const [modalData, setModalData] = useState('');
  const [rowChanged, setRowChanged] = useState(false);
  const [search, setSearch] = useState('');
  const [tableKey, setTableKey] = useState(0);
  const [selectedModules, setSelectedModules] = useState([]);

  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);

  const generateRows = (departments) => {
    return departments.map((item) => {
      const lang =
        item.langKey === 'mne' ? t('language.mneLat') : t('language.english');

      return {
        // id: item?.id,
        activated: item?.active,
        name: item?.name,
        nameEn: item?.nameEn,
        departmentTypeId:
          getLanguage() === 'eng'
            ? item?.departmentTypeNameEn
            : item?.departmentTypeName,
        parentId: item?.parentId ? getLanguage() === 'eng'
          ? item?.parentNameEn
          : item?.parentName  : '',
        sectorDirectorId: item?.sectorDirectorId
          ? `${item?.sectorDirectorFirstName} ${item?.sectorDirectorLastName}`
          : '',
        userResponsibleId: item?.userResponsibleId
          ? `${item?.userResponsibleFirstName} ${item?.userResponsibleLastName}`
          : '',
        userInChargeId: item?.userInChargeId
          ? `${item?.userInChargeFirstName} ${item?.userInChargeLastName}`
          : '',
        userInChargeReplacementId: item?.userInChargeReplacementId
          ? `${item?.userInChargeReplacementFirstName} ${item?.userInChargeReplacementLastName}`
          : '',
        onClick: () => onRowClick(item),
        buttons: [
          item?.active === true && (
            <Edit
              key={`edit-${item?.id}`}
              data={item}
              id="departments"
              setRowChanged={() => onRowChange()}
            />
          ),
          // <Delete
          //   key={`delete-${item?.id}`}
          //   data={item}
          //   id="departments"
          //   setRowChanged={() => onRowChange()}
          // />,
          <Deactivate
            key={`deactivate-${item?.id}`}
            data={item}
            id="departments"
            setRowChanged={() => onRowChange()}
          />,
        ],
      };
    });
  };

  const fetchData = async (requestedPage = 0, reset = false) => {
    if (isLoading) return;

    setIsLoading(true);
    if (requestedPage === 0) {
      setIsLoadingPage(true);
    }

    try {
      const moduleIds = selectedModules.map((m) => m.value);
      const r = await AXIOS.getAllDepartments(requestedPage, PAGE_SIZE, moduleIds, search);
      const data = Array.isArray(r.data) ? r.data : [];
      const newRows = generateRows(data);

      if (reset || requestedPage === 0) {
        setItems(newRows);
        setFilterItems(newRows);
      } else {
        setItems((prev) => [...prev, ...newRows]);
        setFilterItems((prev) => [...prev, ...newRows]);
      }

      setHasMore(data.length === PAGE_SIZE);
      setPage(requestedPage);
    } catch (r) {
      if (r.message === 'Network Error') {
        Swal.fire({
          text: `${t('message.errorServerTitle')}`,
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          text: `${t('message.errorApi')}`,
          icon: 'error',
          confirmButtonText: 'Ok',
        });
      }
    } finally {
      setIsLoading(false);
      setIsLoadingPage(false);
    }
  };

  const fetchMoreData = () => {
    if (isLoading || search || !hasMore) return;
    fetchData(page + 1, false);
  };

  const onRowClick = (item) => {
    setModalData(item);
    setModal((prev) => !prev);
  };

  const onRowChange = () => {
    setSearch('');
    setItems([]);
    setFilterItems([]);
    setPage(0);
    setHasMore(true);
    setRowChanged((prev) => !prev);
    setTableKey((prev) => prev + 1);
  };

  useEffect(() => {
    fetchData(0, true);
  }, [rowChanged, selectedModules, search]);

  const tableHeader = [
    t('departments.name'),
    t('departments.nameEn'),
    t('departments.departmentTypes'),
    t('departments.departments'),
    t('departments.sectorDirector'),
    t('departments.responsibleUsers'),
    t('departments.inChargeUsers'),
    t('departments.users'),
  ];

  return (
    <div style={{padding: '0 30px'}} className="h-100 pb-3">
      <Show
        data={modalData}
        id="departments"
        type="departments"
        modal={modal}
        setModal={setModal}
        isEditable={true}
        setRowChanged={() => onRowChange()}
      />

      <SearchHeader
        placeholder={t('departments.placeholder.search')}
        button={<Add id="departments" setRowChanged={() => onRowChange()} />}
        onChange={(e) => setSearch(e.target.value)}
        searchValue={search}
        showInput={true}
        showButton={true}
        showSelectFilter={
          <Select
            name="appModuleIds"
            className="select"
            options={appModuleIdsOptions}
            placeholder={t('departments.placeholder.selectFilterModules')}
            isClearable={false}
            isMulti={true}
            value={selectedModules}
            onChange={(values) => {
              setSelectedModules(values ?? []);
              setSearch('');
              setItems([]);
              setFilterItems([]);
              setPage(0);
              setHasMore(true);
              setTableKey((key) => key + 1);
            }}
          />
        }
      />

      <div className="position-relative administration-page-table-container pt-4">
        {isLoadingPage && <Loader />}

        <TableAdministration
          key={tableKey}
          tableHeader={tableHeader}
          tableRows={ items}
          fetchMoreData={fetchMoreData}
          hasMore={!search && hasMore}
          editableRow={false}
        />
      </div>
    </div>
  );
};

export default Departments;